import React, {PropsWithChildren, ReactElement} from 'react';
import { ExternalLink } from '@mo/external-link';
import './footer.scss';

const TermsAndConditionsLink: React.FunctionComponent<PropsWithChildren<Record<never,never>>> = ({ children = 'Terms and Conditions' }: PropsWithChildren<Record<never,never>>): ReactElement => (
        <ExternalLink
            href='https://smart.motabilityoperations.co.uk/TermsAndConditions'
            analyticsTag='website-terms-and-conditions'
            withoutIcon
        >
            {children}
        </ExternalLink>
    );

export default TermsAndConditionsLink;
